import React from "react";
import PropTypes from "prop-types";

const ImaginationAndCreativityIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill={props.fill}
      style={props.style}
      viewBox="0 0 2000 2000"
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1353.000000,2001.000000 
	C902.000000,2001.000000 451.500000,2001.000000 1.000000,2001.000000 
	C1.000000,1334.333374 1.000000,667.666687 1.000000,1.000000 
	C667.666687,1.000000 1334.333374,1.000000 2001.000000,1.000000 
	C2001.000000,667.666687 2001.000000,1334.333374 2001.000000,2001.000000 
	C1785.166626,2001.000000 1569.333374,2001.000000 1353.000000,2001.000000 
M463.329956,606.971497 
	C459.417511,611.351257 455.351135,615.605103 451.636505,620.146606 
	C448.004303,624.587158 443.613464,628.876038 441.560638,634.030151 
	C438.440704,641.863342 437.813416,650.003113 440.024933,658.900574 
	C445.526520,681.034790 449.614044,703.521362 454.229614,725.874695 
	C457.545898,741.935364 460.741089,758.021240 464.094696,774.074036 
	C467.406616,789.927368 470.958771,805.731873 474.072662,821.623047 
	C474.396423,823.275330 472.978577,826.196899 471.491516,827.127258 
	C460.892517,833.758118 450.062103,840.018799 439.311584,846.407898 
	C399.076355,870.320190 358.826813,894.208618 318.651917,918.221863 
	C316.283997,919.637207 313.274567,921.767822 312.713959,924.085632 
	C310.975830,931.271851 310.212128,938.700317 309.191711,946.051636 
	C308.162476,953.466125 307.179413,960.890015 306.365204,968.330444 
	C305.806610,973.434631 305.571198,978.574219 305.128754,984.542358 
	C306.582642,983.499817 307.401123,983.025879 308.086212,982.404846 
	C318.795563,972.696411 329.872742,963.351990 340.054443,953.117249 
	C347.393127,945.740295 355.049591,940.961304 365.797058,942.716614 
	C367.550659,943.003052 369.431183,942.416199 371.256226,942.375183 
	C410.378876,941.496948 449.501007,940.588745 488.625671,939.809570 
	C499.398804,939.595032 510.179840,939.776917 521.084167,939.776917 
	C521.224609,937.353699 521.347839,936.218079 521.348083,935.082458 
	C521.357544,883.915833 521.393799,832.749023 521.236206,781.582886 
	C521.228943,779.212830 520.005615,776.399719 518.447388,774.553711 
	C508.240509,762.461609 497.740417,750.617798 487.426147,738.615479 
	C479.867279,729.819580 472.445770,720.905701 465.060822,711.105225 
	C465.059082,677.825684 465.070496,644.546204 465.012024,611.266724 
	C465.009430,609.793091 464.369476,608.320618 463.329956,606.971497 
M1753.400635,1062.207275 
	C1743.591553,1062.145752 1733.782471,1062.084229 1723.044922,1062.002563 
	C1718.375488,1061.962402 1713.706177,1061.922241 1708.831421,1061.578125 
	C1708.533081,1061.649292 1708.234863,1061.720337 1707.017578,1061.853394 
	C1702.700073,1061.788940 1698.382446,1061.724487 1693.392822,1061.163696 
	C1683.893555,1061.137939 1674.394287,1061.112183 1663.971436,1061.049316 
	C1654.334839,1060.939941 1644.698120,1060.830566 1634.400635,1060.207275 
	C1624.578979,1060.155518 1614.757202,1060.103882 1604.006592,1060.027100 
	C1589.217896,1060.027100 1574.429199,1060.027100 1559.486450,1060.027100 
	C1559.004028,1062.856445 1558.568726,1065.229736 1558.198975,1067.613159 
	C1557.301636,1073.396240 1556.749390,1079.256714 1555.438354,1084.943237 
	C1554.641235,1088.400391 1555.257935,1090.007080 1558.690430,1091.078247 
	C1566.582031,1093.541016 1574.305908,1096.558105 1582.238525,1098.866455 
	C1586.070923,1099.981567 1588.122314,1102.177002 1588.865967,1105.772827 
	C1592.967163,1125.606689 1597.104126,1145.434814 1600.925781,1165.323120 
	C1601.495728,1168.288696 1601.909790,1171.766968 1598.208618,1174.095581 
	C1584.426392,1182.766113 1570.787354,1191.664551 1557.117798,1200.513306 
	C1551.104980,1204.405640 1543.876221,1207.693359 1548.220459,1217.174805 
	C1548.462036,1217.702026 1548.072754,1218.485840 1548.118530,1219.140259 
	C1548.449829,1223.883911 1548.706787,1228.636475 1549.197266,1233.364380 
	C1550.124268,1242.299316 1551.329468,1251.206909 1552.161987,1260.149780 
	C1552.965820,1268.787231 1553.283569,1277.470581 1554.113770,1286.104980 
	C1554.957886,1294.883667 1556.338379,1303.610840 1557.167603,1312.390503 
	C1557.998779,1321.190918 1558.333740,1330.036865 1559.079224,1338.846680 
	C1559.947021,1349.103516 1561.031860,1359.341919 1562.006592,1369.589844 
	C1562.410156,1373.832886 1562.699219,1378.088013 1563.168091,1382.323486 
	C1564.139160,1391.094482 1565.350830,1399.841553 1566.172485,1408.625610 
	C1566.980103,1417.262085 1567.318115,1425.941528 1568.061279,1434.585083 
	C1568.929199,1444.682983 1570.011963,1454.762451 1571.003418,1464.849731 
	C1571.418823,1469.076660 1571.804810,1473.306763 1572.265625,1477.528687 
	C1572.887207,1483.223755 1573.667603,1488.902954 1574.192871,1494.606201 
	C1574.642334,1499.487671 1574.661255,1504.410645 1575.167603,1509.284546 
	C1576.062256,1517.896118 1577.354736,1526.468384 1578.161133,1535.087036 
	C1578.984497,1543.890015 1579.296631,1552.739990 1580.060669,1561.549683 
	C1581.275391,1575.555298 1582.611328,1589.551392 1584.037476,1603.537109 
	C1584.594116,1608.995850 1585.533813,1614.415405 1586.286011,1619.760864 
	C1641.093628,1619.760864 1695.326050,1619.760864 1749.773926,1619.760864 
	C1750.559937,1610.192139 1751.222778,1600.965088 1752.097046,1591.758057 
	C1753.315308,1578.926392 1754.706909,1566.111572 1755.994263,1553.286377 
	C1756.770386,1545.554565 1757.465088,1537.814453 1758.239258,1530.082520 
	C1759.473999,1517.752808 1760.783203,1505.430420 1761.986328,1493.097656 
	C1762.789673,1484.863159 1763.395996,1476.609497 1764.212036,1468.376343 
	C1765.417847,1456.207642 1766.787476,1444.055176 1767.984009,1431.885498 
	C1769.116211,1420.369263 1770.053833,1408.833862 1771.190063,1397.318115 
	C1772.390381,1385.152222 1773.801514,1373.006958 1774.977295,1360.838867 
	C1776.106689,1349.148804 1776.954346,1337.431274 1778.106567,1325.743530 
	C1779.289673,1313.741455 1780.799683,1301.771484 1781.966675,1289.768066 
	C1783.118896,1277.913330 1783.884155,1266.020874 1785.067505,1254.169678 
	C1786.560913,1239.211792 1788.264160,1224.274292 1789.971558,1209.338867 
	C1790.394287,1205.639893 1789.346924,1203.385010 1785.857300,1201.368042 
	C1768.296509,1191.218018 1750.954956,1180.689209 1733.497803,1170.358765 
	C1730.502930,1168.586426 1729.733765,1166.291748 1730.321533,1162.914307 
	C1733.309692,1145.744141 1736.282471,1128.567993 1738.900879,1111.339233 
	C1739.650024,1106.409668 1741.518188,1103.460449 1746.410889,1101.795532 
	C1754.650024,1098.992065 1762.692993,1095.600586 1770.752930,1092.296265 
	C1771.936157,1091.811157 1773.592407,1090.466919 1773.617554,1089.484131 
	C1773.841553,1080.730713 1773.747925,1071.969238 1773.747925,1062.721191 
	C1766.705444,1062.721191 1760.383545,1062.721191 1753.400635,1062.207275 
M1392.954712,959.493530 
	C1392.548340,959.482910 1392.142090,959.472351 1391.735718,959.461731 
	C1392.174072,959.625549 1392.612427,959.789368 1393.219849,960.623047 
	C1415.965576,973.819214 1438.708984,987.019470 1461.458374,1000.209106 
	C1468.705811,1004.411011 1469.206543,1007.214844 1463.574341,1013.287720 
	C1440.361084,1038.317627 1417.060425,1063.267090 1393.957397,1088.397949 
	C1390.735229,1091.902954 1387.683105,1092.948608 1383.004517,1091.883667 
	C1324.774780,1078.629150 1266.506592,1065.544189 1208.246094,1052.425049 
	C1194.980103,1049.437744 1181.706299,1046.486084 1169.411011,1043.735962 
	C1080.849121,1147.072632 992.855774,1249.745850 904.862427,1352.419067 
	C904.838989,1352.955200 904.815552,1353.491333 904.792053,1354.027588 
	C912.775696,1349.734009 915.214905,1354.929565 918.030396,1360.027954 
	C933.957458,1388.869263 949.990540,1417.652100 966.001770,1446.446899 
	C970.310669,1454.195801 969.579346,1456.217896 961.293396,1459.303711 
	C891.929504,1485.135010 822.576599,1510.995728 753.175415,1536.726196 
	C750.033142,1537.891235 749.006775,1539.346558 748.772705,1542.686523 
	C746.969604,1568.418091 744.885864,1594.129883 742.934143,1619.851196 
	C742.637756,1623.756836 740.867920,1625.996948 736.811279,1626.322021 
	C730.839600,1626.800171 724.878479,1627.408936 718.911072,1627.942261 
	C709.076843,1628.821167 699.241089,1629.684326 688.649658,1630.621094 
	C689.891907,1631.602783 690.409424,1632.242676 691.075623,1632.504395 
	C708.362061,1639.298462 725.529114,1646.428589 743.003418,1652.702148 
	C758.534546,1658.278320 774.206299,1663.702148 790.184448,1667.732178 
	C809.420715,1672.584106 828.979553,1676.266479 848.523804,1679.753906 
	C864.969666,1682.688477 881.542725,1685.124878 898.156982,1686.834473 
	C911.559875,1688.213745 925.112000,1688.742798 938.591125,1688.650879 
	C964.251526,1688.476074 989.928345,1688.032959 1015.555664,1686.808594 
	C1028.370850,1686.196167 1041.138428,1683.905029 1053.844238,1681.856567 
	C1070.674316,1679.143188 1087.702515,1676.989624 1104.141479,1672.674927 
	C1129.475464,1666.025146 1154.599854,1658.390503 1179.416016,1649.999268 
	C1213.124023,1638.601318 1245.155884,1623.268555 1276.199707,1605.870728 
	C1299.125000,1593.022583 1321.107422,1578.752808 1342.326050,1563.251587 
	C1372.399170,1541.281372 1400.765137,1517.340332 1426.226685,1490.137451 
	C1440.741333,1474.629883 1455.219116,1459.001587 1468.542480,1442.483276 
	C1497.960571,1406.011108 1522.991943,1366.632690 1543.818359,1324.601074 
	C1546.195679,1319.803467 1546.164795,1315.109497 1545.720337,1310.164673 
	C1545.543823,1308.200317 1545.186035,1306.251953 1545.010010,1304.287598 
	C1544.242310,1295.718384 1543.578735,1287.139282 1542.750610,1278.576050 
	C1541.557983,1266.244141 1540.243286,1253.924072 1539.004150,1241.596680 
	C1538.028687,1231.891724 1536.820435,1222.199219 1536.243530,1212.469849 
	C1535.942993,1207.401245 1534.215820,1202.262817 1540.832520,1198.269287 
	C1556.341187,1188.908569 1571.036621,1178.209595 1586.313599,1168.447266 
	C1589.168457,1166.622925 1589.380859,1164.614502 1588.896240,1162.301147 
	C1585.393555,1145.580933 1581.567993,1128.927002 1578.214355,1112.178223 
	C1577.683228,1109.526489 1576.631958,1108.691406 1574.453735,1107.979126 
	C1565.597046,1105.082520 1556.808960,1101.973755 1547.934204,1099.134888 
	C1543.876831,1097.837036 1542.467163,1095.205933 1543.040649,1091.241943 
	C1544.683716,1079.882568 1546.358276,1068.527588 1548.030029,1057.172363 
	C1549.140747,1049.628296 1550.683960,1048.045410 1556.969849,1048.006958 
	C1558.300781,1047.998779 1559.632080,1048.078613 1561.168457,1048.421875 
	C1561.466797,1048.350830 1561.765137,1048.279663 1562.982056,1048.146851 
	C1567.302002,1048.182739 1571.621826,1048.218506 1576.605835,1048.763428 
	C1586.425415,1048.824829 1596.244873,1048.886230 1606.906128,1048.969360 
	C1610.580566,1049.586426 1612.002930,1048.145508 1611.821289,1044.341064 
	C1610.801514,1022.976501 1610.206909,1001.588074 1608.905273,980.242065 
	C1608.092041,966.903931 1607.122070,953.475281 1604.747559,940.354187 
	C1600.422485,916.455383 1595.548096,892.624512 1589.915161,869.000793 
	C1580.044556,827.604675 1564.639282,788.130798 1546.136719,749.880371 
	C1530.443726,717.438477 1511.975220,686.625183 1491.063477,657.238098 
	C1465.682373,621.570129 1437.232544,588.666382 1405.297485,558.693481 
	C1374.775024,530.046265 1341.876221,504.560944 1306.594238,482.075745 
	C1274.959229,461.914856 1241.809814,444.617920 1207.158325,430.359222 
	C1157.253540,409.823975 1105.709473,394.860443 1052.059082,388.079803 
	C1028.789795,385.138885 1005.385803,383.131439 981.993347,381.353271 
	C969.728333,380.420959 957.356018,380.900177 944.818054,380.449615 
	C944.536987,380.578766 944.255981,380.707916 943.051697,380.977020 
	C866.610840,382.899933 792.648621,397.183716 720.479797,425.144348 
	C726.625061,430.807465 732.269836,435.682404 737.546082,440.927917 
	C760.826904,464.073181 783.930847,487.396912 807.291138,510.461273 
	C810.785400,513.911255 811.370605,517.026794 809.955505,521.542603 
	C772.557129,640.886902 735.239807,760.256653 698.023010,879.657654 
	C696.514221,884.498291 693.967163,886.253662 689.001099,886.085388 
	C680.070557,885.782898 671.122559,885.999878 662.793396,885.999878 
	C662.793396,902.791382 662.793396,918.980225 662.793396,934.354614 
	C677.859436,934.354614 692.002625,934.576843 706.136292,934.307068 
	C733.266907,933.789246 760.394226,933.057922 787.517639,932.240662 
	C791.625671,932.116882 794.050842,933.500488 795.605835,937.264221 
	C821.385742,999.662964 847.216125,1062.040894 873.044128,1124.419800 
	C875.561707,1130.500122 878.138245,1136.555908 881.172913,1143.778809 
	C882.970764,1141.602051 884.019348,1140.098145 885.295410,1138.821289 
	C949.143799,1074.937744 1013.010742,1011.072754 1076.878418,947.208557 
	C1082.939575,941.147766 1084.909180,941.220581 1090.450928,947.860840 
	C1103.150269,963.077454 1115.806030,978.330383 1128.496094,993.554626 
	C1135.298950,1001.715942 1142.136353,1009.848389 1149.831177,1019.036377 
	C1143.507080,987.915466 1137.500732,958.243591 1131.425293,928.585938 
	C1130.536255,924.246338 1130.167114,920.582520 1133.668335,916.663269 
	C1182.041016,862.514526 1230.221680,808.194153 1278.464233,753.928955 
	C1283.959717,747.747375 1288.319946,748.663391 1290.936035,756.503540 
	C1296.407959,772.902588 1301.668701,789.375671 1307.420532,805.675537 
	C1309.125000,810.505310 1308.557983,814.001709 1305.409790,817.989136 
	C1293.546753,833.013794 1281.989502,848.279846 1269.980103,863.894653 
	C1274.949829,865.394165 1279.524170,866.788147 1284.106689,868.155029 
	C1343.070435,885.743286 1402.036377,903.324280 1460.998657,920.917786 
	C1467.042847,922.721313 1468.154541,924.758911 1466.449097,930.818909 
	C1463.205444,942.344482 1459.960327,953.869629 1456.669312,965.381775 
	C1454.633545,972.503418 1452.956299,973.510254 1445.922119,971.864685 
	C1438.151733,970.046875 1430.420166,968.057922 1422.631104,966.325989 
	C1412.766724,964.132507 1402.861450,962.123047 1392.954712,959.493530 
M430.054657,1142.465088 
	C465.345398,1240.008789 500.636139,1337.552490 535.975220,1435.229736 
	C537.404358,1435.044678 538.388062,1434.994263 539.336060,1434.783447 
	C607.855347,1419.549683 676.363220,1404.263794 744.911743,1389.162476 
	C748.724670,1388.322632 749.543823,1386.413452 749.787842,1383.135986 
	C752.531921,1346.281616 755.330750,1309.431519 758.135803,1272.581665 
	C760.536560,1241.043335 762.950500,1209.505981 765.384094,1177.970093 
	C768.278687,1140.460571 771.198242,1102.952759 774.111206,1065.444458 
	C776.302429,1037.230469 778.516968,1009.018188 780.687134,980.802551 
	C781.616211,968.723511 782.458740,956.637756 783.384277,943.956909 
	C743.103943,944.950195 703.298706,945.931824 663.999756,946.900940 
	C663.999756,959.472412 663.857788,971.273132 664.078613,983.067017 
	C664.153442,987.063477 662.755188,989.530945 659.383667,991.586914 
	C646.735718,999.299622 634.156799,1007.130554 621.690247,1015.132507 
	C618.184814,1017.382507 615.134949,1017.476257 611.443481,1015.724731 
	C583.488770,1002.460144 555.513977,989.236023 527.442749,976.220764 
	C522.808228,974.071960 520.948914,971.181091 521.278198,966.160156 
	C521.620422,960.941345 521.354492,955.682617 521.354492,950.296265 
	C467.766815,951.588257 415.092255,952.858276 361.932617,954.139954 
	C384.683563,1016.968567 407.267883,1079.337036 430.054657,1142.465088 
M527.900452,1445.597900 
	C527.289062,1444.239258 526.584900,1442.914062 526.079590,1441.517090 
	C483.658783,1324.236084 441.259399,1206.947266 398.843750,1089.664429 
	C383.124664,1046.199829 367.370087,1002.747986 351.458588,958.812256 
	C348.912109,960.758423 346.462860,962.393188 344.288361,964.335510 
	C337.056976,970.794495 329.916779,977.355713 322.755646,983.893066 
	C310.848328,994.763245 298.898438,1005.587585 287.067535,1016.540405 
	C277.273163,1025.607788 267.692291,1034.906006 257.882141,1043.956055 
	C253.194366,1048.280640 248.413330,1052.568237 243.264877,1056.308594 
	C239.300201,1059.188965 240.071625,1062.388306 241.470169,1065.799316 
	C246.891525,1079.022339 252.502914,1092.167236 257.929169,1105.388306 
	C264.401672,1121.158447 270.749542,1136.979736 277.165070,1152.773315 
	C283.758820,1169.005615 290.388092,1185.223633 296.966766,1201.461914 
	C303.968811,1218.745239 310.904388,1236.055420 317.915436,1253.335083 
	C325.223175,1271.345947 332.597321,1289.329712 339.922028,1307.333618 
	C346.346100,1323.123901 352.736023,1338.928101 359.151611,1354.721924 
	C365.745331,1370.954102 372.386749,1387.166870 378.942810,1403.414185 
	C384.951904,1418.306152 390.831116,1433.250244 396.848785,1448.138672 
	C402.520233,1462.170410 408.328796,1476.146606 414.019592,1490.170532 
	C419.277954,1503.128784 424.447601,1516.123169 429.678955,1529.092407 
	C435.808502,1544.288330 441.854828,1559.519287 448.178162,1574.634399 
	C449.857208,1578.647949 451.471344,1583.987549 454.739136,1585.815796 
	C469.939697,1594.319824 485.680573,1601.864624 501.291443,1609.625366 
	C507.323975,1612.624268 512.805603,1614.294434 520.312927,1611.476318 
	C643.155823,1565.365112 766.177551,1519.730347 889.157166,1473.983276 
	C910.813416,1465.927368 932.461487,1457.849487 954.252380,1449.730103 
	C953.943970,1448.868896 953.806702,1448.219360 953.498962,1447.664307 
	C938.654785,1420.894897 923.762939,1394.152100 908.993530,1367.341675 
	C907.614258,1364.838013 906.121521,1364.906738 903.734497,1365.439819 
	C854.223816,1376.495239 804.692810,1387.459595 755.168152,1398.452515 
	C681.908020,1414.714233 608.654358,1431.005371 535.367493,1447.145996 
	C533.218384,1447.619141 530.727417,1446.540771 527.900452,1445.597900 
M475.866394,526.500000 
	C475.866394,583.316040 475.962494,640.132385 475.755066,696.947632 
	C475.726440,704.787903 476.212891,711.729248 483.351898,716.687561 
	C485.681946,718.305786 487.271271,720.994812 489.187164,723.204651 
	C532.057739,772.652466 574.904175,822.121399 617.889587,871.469177 
	C619.385925,873.186829 622.253723,874.604675 624.501343,874.632751 
	C644.159119,874.877930 663.821655,874.716797 683.481750,874.836426 
	C686.439697,874.854431 687.835754,874.024231 688.756714,871.070557 
	C725.037415,754.707397 761.399536,638.369568 797.818420,522.049561 
	C798.673035,519.319885 798.247498,517.595154 796.191406,515.548401 
	C759.704651,479.227112 723.329163,442.793945 686.787537,406.528107 
	C685.372192,405.123505 682.320740,404.203400 680.398926,404.647339 
	C650.438110,411.568573 620.537231,418.749207 590.623901,425.875885 
	C554.146240,434.566528 517.702454,443.405060 481.151337,451.774841 
	C476.622681,452.811859 475.750427,454.386871 475.783020,458.520508 
	C475.959106,480.845825 475.866394,503.173279 475.866394,526.500000 
M847.276367,1092.198486 
	C829.567200,1049.451904 811.857971,1006.705383 794.148743,963.958801 
	C792.870728,970.184387 792.415466,976.110535 791.965576,982.037048 
	C789.849304,1009.913818 787.756226,1037.792480 785.613525,1065.667236 
	C783.062805,1098.848877 780.478271,1132.027832 777.892639,1165.206665 
	C776.031067,1189.094727 774.061340,1212.974854 772.319519,1236.871582 
	C771.815796,1243.782837 770.261292,1251.208496 772.052612,1257.594849 
	C780.224060,1286.727783 789.447754,1315.564941 798.187256,1344.540283 
	C799.016663,1347.290161 800.456970,1348.460449 803.221191,1349.127686 
	C818.902588,1352.912720 834.581238,1356.731445 850.152893,1360.938477 
	C857.093323,1362.813599 863.778442,1363.451782 870.677063,1361.127808 
	C873.184753,1360.283203 875.828064,1359.634399 878.454956,1359.395020 
	C883.311707,1358.952393 886.481995,1356.325806 889.551392,1352.739380 
	C967.505737,1261.650391 1045.546753,1170.635742 1123.570312,1079.606201 
	C1133.938599,1067.509644 1144.295166,1055.402954 1154.840576,1043.086548 
	C1130.910400,1014.354126 1107.209351,985.896851 1082.731323,956.506592 
	C1081.219604,958.514099 1080.275391,960.134583 1078.993408,961.417480 
	C1014.455322,1026.004761 949.890137,1090.565063 885.321228,1155.121582 
	C879.292175,1161.149414 875.636230,1160.484009 872.443481,1152.793091 
	C864.155273,1132.828613 855.886841,1112.855835 847.276367,1092.198486 
M1451.167725,942.703796 
	C1452.241455,938.909241 1453.315186,935.114685 1454.464233,931.053833 
	C1452.284424,930.312683 1450.602539,929.677246 1448.883789,929.165649 
	C1386.717529,910.658936 1324.547607,892.164490 1262.378906,873.666260 
	C1253.603394,871.055237 1252.516113,867.793762 1258.030884,860.615601 
	C1270.106567,844.897583 1282.223267,829.210754 1294.204468,813.421021 
	C1295.264160,812.024414 1296.354370,809.684937 1295.907715,808.261169 
	C1291.644531,794.676758 1287.052734,781.195435 1282.151245,766.470642 
	C1280.623413,768.437683 1279.697632,769.781494 1278.622070,770.992310 
	C1234.159790,821.051880 1189.712769,871.125061 1145.129883,921.077148 
	C1142.776611,923.713867 1142.528687,926.067871 1143.160645,929.147217 
	C1149.715576,961.084595 1156.352295,993.006531 1162.577515,1025.008423 
	C1163.471313,1029.602783 1165.321655,1031.177856 1169.611450,1032.133545 
	C1239.918091,1047.798462 1310.197144,1063.586914 1380.440918,1079.530518 
	C1384.291382,1080.404297 1386.531616,1079.564209 1389.033203,1076.805176 
	C1398.652100,1066.195923 1408.480225,1055.776611 1418.222900,1045.279541 
	C1429.539429,1033.087036 1440.848022,1020.887268 1452.496460,1008.327942 
	C1440.075684,1001.115906 1428.015991,994.101990 1415.944946,987.107422 
	C1394.632568,974.757812 1373.305176,962.433838 1352.003296,950.066101 
	C1347.462036,947.429443 1345.809448,943.532227 1348.648438,940.963074 
	C1350.353271,939.420227 1353.817627,938.643372 1356.137939,939.147766 
	C1372.709717,942.749939 1389.188599,946.778931 1405.700928,950.655518 
	C1419.100098,953.801086 1432.504761,956.923706 1446.171753,960.118408 
	C1447.862793,954.318726 1449.440063,948.909546 1451.167725,942.703796 
M368.205475,611.705322 
	C361.724884,618.185608 355.588776,625.067505 348.652344,631.016235 
	C343.312439,635.595703 343.835724,640.965454 344.352844,646.700928 
	C344.926666,653.065857 345.653198,659.418030 346.151520,665.788391 
	C346.574036,671.189148 346.595764,676.623779 347.097137,682.015320 
	C348.036621,692.119202 349.364258,702.188538 350.213165,712.298828 
	C351.022552,721.938538 351.317627,731.620544 352.038574,741.268982 
	C352.917236,753.027954 354.009064,764.771118 354.999359,776.521851 
	C355.385132,781.099426 355.682281,785.685303 356.130310,790.256531 
	C357.136505,800.522339 358.371338,810.769531 359.134979,821.052368 
	C359.303528,823.321777 358.253143,825.887146 357.166260,828.010193 
	C351.211731,839.641235 345.095123,851.189697 338.988159,862.742188 
	C331.428894,877.042053 323.824677,891.318115 316.239868,905.604431 
	C316.500031,905.859192 316.760223,906.113892 317.020386,906.368652 
	C365.648743,877.494873 414.277100,848.621094 462.924561,819.736023 
	C459.580444,804.647827 456.199005,789.957275 453.080536,775.211060 
	C444.993805,736.972107 436.977448,698.718140 429.063263,660.443176 
	C428.076385,655.670349 427.129913,650.678467 427.494141,645.889160 
	C427.976257,639.549500 429.776672,633.311035 430.996552,627.026367 
	C435.911926,601.702515 440.843109,576.381836 445.718903,551.050415 
	C446.932739,544.744202 447.961212,538.402222 449.074890,532.076721 
	C448.770264,531.968018 448.465637,531.859375 448.161011,531.750732 
	C421.675842,558.235596 395.190704,584.720459 368.205475,611.705322 
M514.233582,1634.992676 
	C516.992737,1634.570801 519.738647,1633.976685 522.513855,1633.764282 
	C527.581665,1633.376221 532.683716,1633.395020 537.741028,1632.920166 
	C547.682556,1631.986938 557.589783,1630.677124 567.536438,1629.813232 
	C576.844116,1629.004883 586.202026,1628.767456 595.506042,1627.927124 
	C608.873047,1626.719482 622.198669,1625.051880 635.566223,1623.851074 
	C645.036438,1623.000488 654.564453,1622.793457 664.035278,1621.947998 
	C677.899719,1620.710327 691.733154,1619.128784 705.585510,1617.751099 
	C714.309021,1616.883301 723.042908,1616.119751 731.837830,1615.303467 
	C733.698486,1590.955933 735.517883,1567.148071 737.378906,1542.795776 
	C735.169922,1543.548462 733.761597,1543.990601 732.379944,1544.504639 
	C660.368835,1571.302490 588.371643,1598.137939 516.304932,1624.785522 
	C513.640625,1625.770752 509.809387,1625.951294 507.352142,1624.773926 
	C487.354889,1615.194336 467.506775,1605.296875 447.760620,1595.208008 
	C445.384033,1593.993774 443.263794,1591.351074 442.101562,1588.866699 
	C439.043488,1582.329712 436.589996,1575.510498 433.876373,1568.811523 
	C418.505676,1530.866699 403.145721,1492.917358 387.744629,1454.984863 
	C383.331482,1444.115479 378.793884,1433.296631 374.313385,1422.454590 
	C373.828125,1422.547241 373.342865,1422.639771 372.857605,1422.732422 
	C373.237335,1426.158325 373.825500,1429.576050 373.958496,1433.011475 
	C374.393982,1444.260132 374.662109,1455.515259 374.997894,1466.767822 
	C375.328705,1477.852173 375.665375,1488.936401 375.996185,1500.020752 
	C376.332001,1511.273438 376.662079,1522.526001 376.997925,1533.778687 
	C377.328735,1544.863037 377.671143,1555.947021 377.994598,1567.031616 
	C378.337524,1578.783936 378.691895,1590.535889 378.990570,1602.289307 
	C379.355865,1616.665527 379.668488,1631.043091 380.016052,1645.941284 
	C383.428406,1645.941284 386.228333,1646.169312 388.979553,1645.899780 
	C398.585938,1644.958740 408.161743,1643.689575 417.775421,1642.843262 
	C427.088593,1642.023193 436.442352,1641.673950 445.763306,1640.930054 
	C456.691528,1640.057983 467.602509,1638.970703 478.523132,1638.001343 
	C483.102936,1637.594849 487.690033,1637.271484 492.270691,1636.874023 
	C499.280273,1636.266113 506.287140,1635.626831 514.233582,1634.992676 
M649.223816,886.070496 
	C639.557983,886.046814 629.889038,885.875183 620.227783,886.074463 
	C616.520203,886.150940 614.040283,884.844910 611.667786,882.087891 
	C591.241943,858.350586 570.705078,834.708801 550.194641,811.044373 
	C544.720154,804.728088 539.222534,798.431885 533.136292,791.437744 
	C532.978333,793.244141 532.874817,793.875854 532.874695,794.507568 
	C532.866699,850.507385 532.889832,906.507263 532.798706,962.506897 
	C532.794067,965.339417 533.880310,966.557251 536.281555,967.677979 
	C561.902222,979.635620 587.450623,991.748657 613.106079,1003.630493 
	C614.648621,1004.344910 617.320251,1004.103455 618.810120,1003.211060 
	C629.090942,997.053284 639.160156,990.543396 649.389038,984.296753 
	C651.592834,982.950867 652.541382,981.655640 652.454163,978.852783 
	C651.925659,961.876648 651.745789,944.890076 651.333374,927.909790 
	C650.997986,914.100830 650.500061,900.295837 649.223816,886.070496 
M833.337280,1368.565796 
	C821.109924,1365.431152 808.934998,1362.064819 796.628601,1359.279053 
	C791.881958,1358.204590 789.661865,1355.798218 788.339478,1351.317627 
	C783.072021,1333.469849 777.532776,1315.702148 772.074768,1297.910767 
	C771.083374,1294.679077 770.000854,1291.475464 768.960388,1288.258911 
	C768.758423,1288.333008 768.556519,1288.407227 768.354553,1288.481445 
	C765.888489,1320.677856 763.422363,1352.874268 760.913757,1385.626221 
	C785.517090,1380.041504 809.326294,1374.637207 833.337280,1368.565796 
M345.339630,804.005493 
	C338.537598,821.778809 332.195496,839.695801 328.130432,858.344910 
	C334.064606,847.846619 339.239990,837.000000 345.216034,826.614014 
	C349.724304,818.778931 346.883545,811.242798 345.339630,804.005493 
z"
      />
      <path
        fill="#0F70B7"
        opacity="1.000000"
        stroke="none"
        d="
M1560.963257,1048.118042 
	C1559.632080,1048.078613 1558.300781,1047.998779 1556.969849,1048.006958 
	C1550.683960,1048.045410 1549.140747,1049.628296 1548.030029,1057.172363 
	C1546.358276,1068.527588 1544.683716,1079.882568 1543.040649,1091.241943 
	C1542.467163,1095.205933 1543.876831,1097.837036 1547.934204,1099.134888 
	C1556.808960,1101.973755 1565.597046,1105.082520 1574.453735,1107.979126 
	C1576.631958,1108.691406 1577.683228,1109.526489 1578.214355,1112.178223 
	C1581.567993,1128.927002 1585.393555,1145.580933 1588.896240,1162.301147 
	C1589.380859,1164.614502 1589.168457,1166.622925 1586.313599,1168.447266 
	C1571.036621,1178.209595 1556.341187,1188.908569 1540.832520,1198.269287 
	C1534.215820,1202.262817 1535.942993,1207.401245 1536.243530,1212.469849 
	C1536.820435,1222.199219 1538.028687,1231.891724 1539.004150,1241.596680 
	C1540.243286,1253.924072 1541.557983,1266.244141 1542.750610,1278.576050 
	C1543.578735,1287.139282 1544.242310,1295.718384 1545.010010,1304.287598 
	C1545.186035,1306.251953 1545.543823,1308.200317 1545.720337,1310.164673 
	C1546.164795,1315.109497 1546.195679,1319.803467 1543.818359,1324.601074 
	C1522.991943,1366.632690 1497.960571,1406.011108 1468.542480,1442.483276 
	C1455.219116,1459.001587 1440.741333,1474.629883 1426.226685,1490.137451 
	C1400.765137,1517.340332 1372.399170,1541.281372 1342.326050,1563.251587 
	C1321.107422,1578.752808 1299.125000,1593.022583 1276.199707,1605.870728 
	C1245.155884,1623.268555 1213.124023,1638.601318 1179.416016,1649.999268 
	C1154.599854,1658.390503 1129.475464,1666.025146 1104.141479,1672.674927 
	C1087.702515,1676.989624 1070.674316,1679.143188 1053.844238,1681.856567 
	C1041.138428,1683.905029 1028.370850,1686.196167 1015.555664,1686.808594 
	C989.928345,1688.032959 964.251526,1688.476074 938.591125,1688.650879 
	C925.112000,1688.742798 911.559875,1688.213745 898.156982,1686.834473 
	C881.542725,1685.124878 864.969666,1682.688477 848.523804,1679.753906 
	C828.979553,1676.266479 809.420715,1672.584106 790.184448,1667.732178 
	C774.206299,1663.702148 758.534546,1658.278320 743.003418,1652.702148 
	C725.529114,1646.428589 708.362061,1639.298462 691.075623,1632.504395 
	C690.409424,1632.242676 689.891907,1631.602783 688.649658,1630.621094 
	C699.241089,1629.684326 709.076843,1628.821167 718.911072,1627.942261 
	C724.878479,1627.408936 730.839600,1626.800171 736.811279,1626.322021 
	C740.867920,1625.996948 742.637756,1623.756836 742.934143,1619.851196 
	C744.885864,1594.129883 746.969604,1568.418091 748.772705,1542.686523 
	C749.006775,1539.346558 750.033142,1537.891235 753.175415,1536.726196 
	C822.576599,1510.995728 891.929504,1485.135010 961.293396,1459.303711 
	C969.579346,1456.217896 970.310669,1454.195801 966.001770,1446.446899 
	C949.990540,1417.652100 933.957458,1388.869263 918.030396,1360.027954 
	C915.214905,1354.929565 912.775696,1349.734009 904.792053,1354.027588 
	C904.815552,1353.491333 904.838989,1352.955200 904.862427,1352.419067 
	C992.855774,1249.745850 1080.849121,1147.072632 1169.411011,1043.735962 
	C1181.706299,1046.486084 1194.980103,1049.437744 1208.246094,1052.425049 
	C1266.506592,1065.544189 1324.774780,1078.629150 1383.004517,1091.883667 
	C1387.683105,1092.948608 1390.735229,1091.902954 1393.957397,1088.397949 
	C1417.060425,1063.267090 1440.361084,1038.317627 1463.574341,1013.287720 
	C1469.206543,1007.214844 1468.705811,1004.411011 1461.458374,1000.209106 
	C1438.708984,987.019470 1415.965576,973.819214 1393.115479,960.307861 
	C1393.011108,959.992676 1392.973755,960.034119 1392.973755,960.034119 
	C1402.861450,962.123047 1412.766724,964.132507 1422.631104,966.325989 
	C1430.420166,968.057922 1438.151733,970.046875 1445.922119,971.864685 
	C1452.956299,973.510254 1454.633545,972.503418 1456.669312,965.381775 
	C1459.960327,953.869629 1463.205444,942.344482 1466.449097,930.818909 
	C1468.154541,924.758911 1467.042847,922.721313 1460.998657,920.917786 
	C1402.036377,903.324280 1343.070435,885.743286 1284.106689,868.155029 
	C1279.524170,866.788147 1274.949829,865.394165 1269.980103,863.894653 
	C1281.989502,848.279846 1293.546753,833.013794 1305.409790,817.989136 
	C1308.557983,814.001709 1309.125000,810.505310 1307.420532,805.675537 
	C1301.668701,789.375671 1296.407959,772.902588 1290.936035,756.503540 
	C1288.319946,748.663391 1283.959717,747.747375 1278.464233,753.928955 
	C1230.221680,808.194153 1182.041016,862.514526 1133.668335,916.663269 
	C1130.167114,920.582520 1130.536255,924.246338 1131.425293,928.585938 
	C1137.500732,958.243591 1143.507080,987.915466 1149.831177,1019.036377 
	C1142.136353,1009.848389 1135.298950,1001.715942 1128.496094,993.554626 
	C1115.806030,978.330383 1103.150269,963.077454 1090.450928,947.860840 
	C1084.909180,941.220581 1082.939575,941.147766 1076.878418,947.208557 
	C1013.010742,1011.072754 949.143799,1074.937744 885.295410,1138.821289 
	C884.019348,1140.098145 882.970764,1141.602051 881.172913,1143.778809 
	C878.138245,1136.555908 875.561707,1130.500122 873.044128,1124.419800 
	C847.216125,1062.040894 821.385742,999.662964 795.605835,937.264221 
	C794.050842,933.500488 791.625671,932.116882 787.517639,932.240662 
	C760.394226,933.057922 733.266907,933.789246 706.136292,934.307068 
	C692.002625,934.576843 677.859436,934.354614 662.793396,934.354614 
	C662.793396,918.980225 662.793396,902.791382 662.793396,885.999878 
	C671.122559,885.999878 680.070557,885.782898 689.001099,886.085388 
	C693.967163,886.253662 696.514221,884.498291 698.023010,879.657654 
	C735.239807,760.256653 772.557129,640.886902 809.955505,521.542603 
	C811.370605,517.026794 810.785400,513.911255 807.291138,510.461273 
	C783.930847,487.396912 760.826904,464.073181 737.546082,440.927917 
	C732.269836,435.682404 726.625061,430.807465 720.479797,425.144348 
	C792.648621,397.183716 866.610840,382.899933 943.783447,380.948151 
	C944.687500,380.860168 944.859863,380.801025 945.032166,380.741943 
	C957.356018,380.900177 969.728333,380.420959 981.993347,381.353271 
	C1005.385803,383.131439 1028.789795,385.138885 1052.059082,388.079803 
	C1105.709473,394.860443 1157.253540,409.823975 1207.158325,430.359222 
	C1241.809814,444.617920 1274.959229,461.914856 1306.594238,482.075745 
	C1341.876221,504.560944 1374.775024,530.046265 1405.297485,558.693481 
	C1437.232544,588.666382 1465.682373,621.570129 1491.063477,657.238098 
	C1511.975220,686.625183 1530.443726,717.438477 1546.136719,749.880371 
	C1564.639282,788.130798 1580.044556,827.604675 1589.915161,869.000793 
	C1595.548096,892.624512 1600.422485,916.455383 1604.747559,940.354187 
	C1607.122070,953.475281 1608.092041,966.903931 1608.905273,980.242065 
	C1610.206909,1001.588074 1610.801514,1022.976501 1611.821289,1044.341064 
	C1612.002930,1048.145508 1610.580566,1049.586426 1606.132202,1048.746338 
	C1595.552734,1048.433594 1585.747314,1048.343872 1575.941772,1048.254272 
	C1571.621826,1048.218506 1567.302002,1048.182739 1562.253296,1048.086914 
	C1561.337402,1048.057373 1561.150391,1048.087769 1560.963257,1048.118042 
M1238.990112,1470.437256 
	C1270.624756,1467.328369 1302.256226,1464.184570 1333.898804,1461.158813 
	C1337.470825,1460.817261 1339.882568,1459.577759 1340.834106,1455.945068 
	C1344.247681,1442.911865 1347.782593,1429.909912 1351.124756,1416.858521 
	C1352.374878,1411.976929 1350.140991,1409.216431 1345.039185,1409.010498 
	C1337.890625,1408.721924 1330.737671,1408.532959 1323.585571,1408.337402 
	C1308.044922,1407.912720 1292.503784,1407.510986 1276.962769,1407.099731 
	C1291.222900,1400.824707 1305.577515,1395.274048 1320.061523,1390.084229 
	C1324.855713,1388.366455 1326.638428,1385.638550 1325.837402,1380.686523 
	C1324.190552,1370.504883 1322.782227,1360.284668 1321.202759,1350.091797 
	C1320.154785,1343.328979 1318.150024,1342.048706 1311.329468,1343.584717 
	C1303.542114,1345.338623 1295.764404,1347.136597 1287.970459,1348.860718 
	C1283.756836,1349.792847 1279.518433,1350.611938 1274.067749,1351.733887 
	C1275.373657,1349.859741 1275.815308,1349.185669 1276.296509,1348.541016 
	C1280.706177,1342.632690 1280.001465,1339.652466 1273.457764,1336.663818 
	C1262.267334,1331.552856 1251.020508,1326.561157 1239.906738,1321.288940 
	C1235.980591,1319.426514 1232.885986,1319.768799 1229.295288,1322.268188 
	C1216.317505,1331.302246 1203.085693,1339.970947 1190.074219,1348.958130 
	C1187.535156,1350.712036 1185.689453,1350.739014 1182.952759,1349.340454 
	C1170.213745,1342.829834 1157.325684,1336.610962 1144.498779,1330.271729 
	C1140.864380,1328.475830 1137.256836,1326.625488 1133.191162,1324.575317 
	C1148.004639,1310.581543 1162.179810,1297.000488 1176.606689,1283.692261 
	C1180.338013,1280.250122 1181.180542,1277.047607 1179.452271,1272.250977 
	C1174.437744,1258.333740 1169.874634,1244.254150 1165.091187,1230.253052 
	C1162.671631,1223.171021 1160.049438,1222.127808 1153.604126,1225.497803 
	C1085.952881,1260.871216 1018.315735,1296.271606 950.612000,1331.544189 
	C945.974609,1333.960205 944.624512,1336.740112 945.817932,1341.927124 
	C953.723755,1376.286621 961.347778,1410.710815 969.070618,1445.112427 
	C970.391296,1450.995728 972.223450,1452.275879 978.224121,1451.070801 
	C1003.500793,1445.994751 1028.757568,1440.819214 1054.040894,1435.776733 
	C1055.899780,1435.405884 1057.992920,1435.455078 1059.840210,1435.890381 
	C1109.860474,1447.676270 1159.859619,1459.551025 1209.876099,1471.353149 
	C1212.593262,1471.994263 1215.451782,1472.573975 1218.203247,1472.423828 
	C1224.845581,1472.061890 1231.463501,1471.250488 1238.990112,1470.437256 
z"
      />
      <path
        fill="#0F70B7"
        opacity="1.000000"
        stroke="none"
        d="
M429.953430,1142.085205 
	C407.267883,1079.337036 384.683563,1016.968567 361.932617,954.139954 
	C415.092255,952.858276 467.766815,951.588257 521.354492,950.296265 
	C521.354492,955.682617 521.620422,960.941345 521.278198,966.160156 
	C520.948914,971.181091 522.808228,974.071960 527.442749,976.220764 
	C555.513977,989.236023 583.488770,1002.460144 611.443481,1015.724731 
	C615.134949,1017.476257 618.184814,1017.382507 621.690247,1015.132507 
	C634.156799,1007.130554 646.735718,999.299622 659.383667,991.586914 
	C662.755188,989.530945 664.153442,987.063477 664.078613,983.067017 
	C663.857788,971.273132 663.999756,959.472412 663.999756,946.900940 
	C703.298706,945.931824 743.103943,944.950195 783.384277,943.956909 
	C782.458740,956.637756 781.616211,968.723511 780.687134,980.802551 
	C778.516968,1009.018188 776.302429,1037.230469 774.111206,1065.444458 
	C771.198242,1102.952759 768.278687,1140.460571 765.384094,1177.970093 
	C762.950500,1209.505981 760.536560,1241.043335 758.135803,1272.581665 
	C755.330750,1309.431519 752.531921,1346.281616 749.787842,1383.135986 
	C749.543823,1386.413452 748.724670,1388.322632 744.911743,1389.162476 
	C676.363220,1404.263794 607.855347,1419.549683 539.336060,1434.783447 
	C538.388062,1434.994263 537.404358,1435.044678 535.975220,1435.229736 
	C500.636139,1337.552490 465.345398,1240.008789 429.953430,1142.085205 
z"
      />
      <path
        fill="#1070B7"
        opacity="1.000000"
        stroke="none"
        d="
M528.148193,1445.891846 
	C530.727417,1446.540771 533.218384,1447.619141 535.367493,1447.145996 
	C608.654358,1431.005371 681.908020,1414.714233 755.168152,1398.452515 
	C804.692810,1387.459595 854.223816,1376.495239 903.734497,1365.439819 
	C906.121521,1364.906738 907.614258,1364.838013 908.993530,1367.341675 
	C923.762939,1394.152100 938.654785,1420.894897 953.498962,1447.664307 
	C953.806702,1448.219360 953.943970,1448.868896 954.252380,1449.730103 
	C932.461487,1457.849487 910.813416,1465.927368 889.157166,1473.983276 
	C766.177551,1519.730347 643.155823,1565.365112 520.312927,1611.476318 
	C512.805603,1614.294434 507.323975,1612.624268 501.291443,1609.625366 
	C485.680573,1601.864624 469.939697,1594.319824 454.739136,1585.815796 
	C451.471344,1583.987549 449.857208,1578.647949 448.178162,1574.634399 
	C441.854828,1559.519287 435.808502,1544.288330 429.678955,1529.092407 
	C424.447601,1516.123169 419.277954,1503.128784 414.019592,1490.170532 
	C408.328796,1476.146606 402.520233,1462.170410 396.848785,1448.138672 
	C390.831116,1433.250244 384.951904,1418.306152 378.942810,1403.414185 
	C372.386749,1387.166870 365.745331,1370.954102 359.151611,1354.721924 
	C352.736023,1338.928101 346.346100,1323.123901 339.922028,1307.333618 
	C332.597321,1289.329712 325.223175,1271.345947 317.915436,1253.335083 
	C310.904388,1236.055420 303.968811,1218.745239 296.966766,1201.461914 
	C290.388092,1185.223633 283.758820,1169.005615 277.165070,1152.773315 
	C270.749542,1136.979736 264.401672,1121.158447 257.929169,1105.388306 
	C252.502914,1092.167236 246.891525,1079.022339 241.470169,1065.799316 
	C240.071625,1062.388306 239.300201,1059.188965 243.264877,1056.308594 
	C248.413330,1052.568237 253.194366,1048.280640 257.882141,1043.956055 
	C267.692291,1034.906006 277.273163,1025.607788 287.067535,1016.540405 
	C298.898438,1005.587585 310.848328,994.763245 322.755646,983.893066 
	C329.916779,977.355713 337.056976,970.794495 344.288361,964.335510 
	C346.462860,962.393188 348.912109,960.758423 351.458588,958.812256 
	C367.370087,1002.747986 383.124664,1046.199829 398.843750,1089.664429 
	C441.259399,1206.947266 483.658783,1324.236084 526.079590,1441.517090 
	C526.584900,1442.914062 527.289062,1444.239258 528.148193,1445.891846 
z"
      />
      <path
        fill="#0F70B7"
        opacity="1.000000"
        stroke="none"
        d="
M1694.064941,1061.660156 
	C1698.382446,1061.724487 1702.700073,1061.788940 1707.746582,1061.913330 
	C1708.662598,1061.942627 1708.849609,1061.912231 1709.036743,1061.881958 
	C1713.706177,1061.922241 1718.375488,1061.962402 1723.852661,1062.236084 
	C1734.460815,1062.553467 1744.261108,1062.637329 1754.061523,1062.721191 
	C1760.383545,1062.721191 1766.705444,1062.721191 1773.747925,1062.721191 
	C1773.747925,1071.969238 1773.841553,1080.730713 1773.617554,1089.484131 
	C1773.592407,1090.466919 1771.936157,1091.811157 1770.752930,1092.296265 
	C1762.692993,1095.600586 1754.650024,1098.992065 1746.410889,1101.795532 
	C1741.518188,1103.460449 1739.650024,1106.409668 1738.900879,1111.339233 
	C1736.282471,1128.567993 1733.309692,1145.744141 1730.321533,1162.914307 
	C1729.733765,1166.291748 1730.502930,1168.586426 1733.497803,1170.358765 
	C1750.954956,1180.689209 1768.296509,1191.218018 1785.857300,1201.368042 
	C1789.346924,1203.385010 1790.394287,1205.639893 1789.971558,1209.338867 
	C1788.264160,1224.274292 1786.560913,1239.211792 1785.067505,1254.169678 
	C1783.884155,1266.020874 1783.118896,1277.913330 1781.966675,1289.768066 
	C1780.799683,1301.771484 1779.289673,1313.741455 1778.106567,1325.743530 
	C1776.954346,1337.431274 1776.106689,1349.148804 1774.977295,1360.838867 
	C1773.801514,1373.006958 1772.390381,1385.152222 1771.190063,1397.318115 
	C1770.053833,1408.833862 1769.116211,1420.369263 1767.984009,1431.885498 
	C1766.787476,1444.055176 1765.417847,1456.207642 1764.212036,1468.376343 
	C1763.395996,1476.609497 1762.789673,1484.863159 1761.986328,1493.097656 
	C1760.783203,1505.430420 1759.473999,1517.752808 1758.239258,1530.082520 
	C1757.465088,1537.814453 1756.770386,1545.554565 1755.994263,1553.286377 
	C1754.706909,1566.111572 1753.315308,1578.926392 1752.097046,1591.758057 
	C1751.222778,1600.965088 1750.559937,1610.192139 1749.773926,1619.760864 
	C1695.326050,1619.760864 1641.093628,1619.760864 1586.286011,1619.760864 
	C1585.533813,1614.415405 1584.594116,1608.995850 1584.037476,1603.537109 
	C1582.611328,1589.551392 1581.275391,1575.555298 1580.060669,1561.549683 
	C1579.296631,1552.739990 1578.984497,1543.890015 1578.161133,1535.087036 
	C1577.354736,1526.468384 1576.062256,1517.896118 1575.167603,1509.284546 
	C1574.661255,1504.410645 1574.642334,1499.487671 1574.192871,1494.606201 
	C1573.667603,1488.902954 1572.887207,1483.223755 1572.265625,1477.528687 
	C1571.804810,1473.306763 1571.418823,1469.076660 1571.003418,1464.849731 
	C1570.011963,1454.762451 1568.929199,1444.682983 1568.061279,1434.585083 
	C1567.318115,1425.941528 1566.980103,1417.262085 1566.172485,1408.625610 
	C1565.350830,1399.841553 1564.139160,1391.094482 1563.168091,1382.323486 
	C1562.699219,1378.088013 1562.410156,1373.832886 1562.006592,1369.589844 
	C1561.031860,1359.341919 1559.947021,1349.103516 1559.079224,1338.846680 
	C1558.333740,1330.036865 1557.998779,1321.190918 1557.167603,1312.390503 
	C1556.338379,1303.610840 1554.957886,1294.883667 1554.113770,1286.104980 
	C1553.283569,1277.470581 1552.965820,1268.787231 1552.161987,1260.149780 
	C1551.329468,1251.206909 1550.124268,1242.299316 1549.197266,1233.364380 
	C1548.706787,1228.636475 1548.449829,1223.883911 1548.118530,1219.140259 
	C1548.072754,1218.485840 1548.462036,1217.702026 1548.220459,1217.174805 
	C1543.876221,1207.693359 1551.104980,1204.405640 1557.117798,1200.513306 
	C1570.787354,1191.664551 1584.426392,1182.766113 1598.208618,1174.095581 
	C1601.909790,1171.766968 1601.495728,1168.288696 1600.925781,1165.323120 
	C1597.104126,1145.434814 1592.967163,1125.606689 1588.865967,1105.772827 
	C1588.122314,1102.177002 1586.070923,1099.981567 1582.238525,1098.866455 
	C1574.305908,1096.558105 1566.582031,1093.541016 1558.690430,1091.078247 
	C1555.257935,1090.007080 1554.641235,1088.400391 1555.438354,1084.943237 
	C1556.749390,1079.256714 1557.301636,1073.396240 1558.198975,1067.613159 
	C1558.568726,1065.229736 1559.004028,1062.856445 1559.486450,1060.027100 
	C1574.429199,1060.027100 1589.217896,1060.027100 1604.824219,1060.251953 
	C1615.448364,1060.558228 1625.254883,1060.639648 1635.061523,1060.721191 
	C1644.698120,1060.830566 1654.334839,1060.939941 1664.796265,1061.267334 
	C1675.102417,1061.543457 1684.583618,1061.601807 1694.064941,1061.660156 
z"
      />
      <path
        fill="#0F70B7"
        opacity="1.000000"
        stroke="none"
        d="
M475.866394,526.000000 
	C475.866394,503.173279 475.959106,480.845825 475.783020,458.520508 
	C475.750427,454.386871 476.622681,452.811859 481.151337,451.774841 
	C517.702454,443.405060 554.146240,434.566528 590.623901,425.875885 
	C620.537231,418.749207 650.438110,411.568573 680.398926,404.647339 
	C682.320740,404.203400 685.372192,405.123505 686.787537,406.528107 
	C723.329163,442.793945 759.704651,479.227112 796.191406,515.548401 
	C798.247498,517.595154 798.673035,519.319885 797.818420,522.049561 
	C761.399536,638.369568 725.037415,754.707397 688.756714,871.070557 
	C687.835754,874.024231 686.439697,874.854431 683.481750,874.836426 
	C663.821655,874.716797 644.159119,874.877930 624.501343,874.632751 
	C622.253723,874.604675 619.385925,873.186829 617.889587,871.469177 
	C574.904175,822.121399 532.057739,772.652466 489.187164,723.204651 
	C487.271271,720.994812 485.681946,718.305786 483.351898,716.687561 
	C476.212891,711.729248 475.726440,704.787903 475.755066,696.947632 
	C475.962494,640.132385 475.866394,583.316040 475.866394,526.000000 
z"
      />
      <path
        fill="#1070B7"
        opacity="1.000000"
        stroke="none"
        d="
M847.443481,1092.542480 
	C855.886841,1112.855835 864.155273,1132.828613 872.443481,1152.793091 
	C875.636230,1160.484009 879.292175,1161.149414 885.321228,1155.121582 
	C949.890137,1090.565063 1014.455322,1026.004761 1078.993408,961.417480 
	C1080.275391,960.134583 1081.219604,958.514099 1082.731323,956.506592 
	C1107.209351,985.896851 1130.910400,1014.354126 1154.840576,1043.086548 
	C1144.295166,1055.402954 1133.938599,1067.509644 1123.570312,1079.606201 
	C1045.546753,1170.635742 967.505737,1261.650391 889.551392,1352.739380 
	C886.481995,1356.325806 883.311707,1358.952393 878.454956,1359.395020 
	C875.828064,1359.634399 873.184753,1360.283203 870.677063,1361.127808 
	C863.778442,1363.451782 857.093323,1362.813599 850.152893,1360.938477 
	C834.581238,1356.731445 818.902588,1352.912720 803.221191,1349.127686 
	C800.456970,1348.460449 799.016663,1347.290161 798.187256,1344.540283 
	C789.447754,1315.564941 780.224060,1286.727783 772.052612,1257.594849 
	C770.261292,1251.208496 771.815796,1243.782837 772.319519,1236.871582 
	C774.061340,1212.974854 776.031067,1189.094727 777.892639,1165.206665 
	C780.478271,1132.027832 783.062805,1098.848877 785.613525,1065.667236 
	C787.756226,1037.792480 789.849304,1009.913818 791.965576,982.037048 
	C792.415466,976.110535 792.870728,970.184387 794.148743,963.958801 
	C811.857971,1006.705383 829.567200,1049.451904 847.443481,1092.542480 
z"
      />
      <path
        fill="#1070B7"
        opacity="1.000000"
        stroke="none"
        d="
M1451.092529,943.102051 
	C1449.440063,948.909546 1447.862793,954.318726 1446.171753,960.118408 
	C1432.504761,956.923706 1419.100098,953.801086 1405.700928,950.655518 
	C1389.188599,946.778931 1372.709717,942.749939 1356.137939,939.147766 
	C1353.817627,938.643372 1350.353271,939.420227 1348.648438,940.963074 
	C1345.809448,943.532227 1347.462036,947.429443 1352.003296,950.066101 
	C1373.305176,962.433838 1394.632568,974.757812 1415.944946,987.107422 
	C1428.015991,994.101990 1440.075684,1001.115906 1452.496460,1008.327942 
	C1440.848022,1020.887268 1429.539429,1033.087036 1418.222900,1045.279541 
	C1408.480225,1055.776611 1398.652100,1066.195923 1389.033203,1076.805176 
	C1386.531616,1079.564209 1384.291382,1080.404297 1380.440918,1079.530518 
	C1310.197144,1063.586914 1239.918091,1047.798462 1169.611450,1032.133545 
	C1165.321655,1031.177856 1163.471313,1029.602783 1162.577515,1025.008423 
	C1156.352295,993.006531 1149.715576,961.084595 1143.160645,929.147217 
	C1142.528687,926.067871 1142.776611,923.713867 1145.129883,921.077148 
	C1189.712769,871.125061 1234.159790,821.051880 1278.622070,770.992310 
	C1279.697632,769.781494 1280.623413,768.437683 1282.151245,766.470642 
	C1287.052734,781.195435 1291.644531,794.676758 1295.907715,808.261169 
	C1296.354370,809.684937 1295.264160,812.024414 1294.204468,813.421021 
	C1282.223267,829.210754 1270.106567,844.897583 1258.030884,860.615601 
	C1252.516113,867.793762 1253.603394,871.055237 1262.378906,873.666260 
	C1324.547607,892.164490 1386.717529,910.658936 1448.883789,929.165649 
	C1450.602539,929.677246 1452.284424,930.312683 1454.464233,931.053833 
	C1453.315186,935.114685 1452.241455,938.909241 1451.092529,943.102051 
z"
      />
      <path
        fill="#1071B7"
        opacity="1.000000"
        stroke="none"
        d="
M368.455505,611.455322 
	C395.190704,584.720459 421.675842,558.235596 448.161011,531.750732 
	C448.465637,531.859375 448.770264,531.968018 449.074890,532.076721 
	C447.961212,538.402222 446.932739,544.744202 445.718903,551.050415 
	C440.843109,576.381836 435.911926,601.702515 430.996552,627.026367 
	C429.776672,633.311035 427.976257,639.549500 427.494141,645.889160 
	C427.129913,650.678467 428.076385,655.670349 429.063263,660.443176 
	C436.977448,698.718140 444.993805,736.972107 453.080536,775.211060 
	C456.199005,789.957275 459.580444,804.647827 462.924561,819.736023 
	C414.277100,848.621094 365.648743,877.494873 317.020386,906.368652 
	C316.760223,906.113892 316.500031,905.859192 316.239868,905.604431 
	C323.824677,891.318115 331.428894,877.042053 338.988159,862.742188 
	C345.095123,851.189697 351.211731,839.641235 357.166260,828.010193 
	C358.253143,825.887146 359.303528,823.321777 359.134979,821.052368 
	C358.371338,810.769531 357.136505,800.522339 356.130310,790.256531 
	C355.682281,785.685303 355.385132,781.099426 354.999359,776.521851 
	C354.009064,764.771118 352.917236,753.027954 352.038574,741.268982 
	C351.317627,731.620544 351.022552,721.938538 350.213165,712.298828 
	C349.364258,702.188538 348.036621,692.119202 347.097137,682.015320 
	C346.595764,676.623779 346.574036,671.189148 346.151520,665.788391 
	C345.653198,659.418030 344.926666,653.065857 344.352844,646.700928 
	C343.835724,640.965454 343.312439,635.595703 348.652344,631.016235 
	C355.588776,625.067505 361.724884,618.185608 368.455505,611.455322 
z"
      />
      <path
        fill="#1070B7"
        opacity="1.000000"
        stroke="none"
        d="
M464.963043,712.044373 
	C472.445770,720.905701 479.867279,729.819580 487.426147,738.615479 
	C497.740417,750.617798 508.240509,762.461609 518.447388,774.553711 
	C520.005615,776.399719 521.228943,779.212830 521.236206,781.582886 
	C521.393799,832.749023 521.357544,883.915833 521.348083,935.082458 
	C521.347839,936.218079 521.224609,937.353699 521.084167,939.776917 
	C510.179840,939.776917 499.398804,939.595032 488.625671,939.809570 
	C449.501007,940.588745 410.378876,941.496948 371.256226,942.375183 
	C369.431183,942.416199 367.550659,943.003052 365.797058,942.716614 
	C355.049591,940.961304 347.393127,945.740295 340.054443,953.117249 
	C329.872742,963.351990 318.795563,972.696411 308.086212,982.404846 
	C307.401123,983.025879 306.582642,983.499817 305.128754,984.542358 
	C305.571198,978.574219 305.806610,973.434631 306.365204,968.330444 
	C307.179413,960.890015 308.162476,953.466125 309.191711,946.051636 
	C310.212128,938.700317 310.975830,931.271851 312.713959,924.085632 
	C313.274567,921.767822 316.283997,919.637207 318.651917,918.221863 
	C358.826813,894.208618 399.076355,870.320190 439.311584,846.407898 
	C450.062103,840.018799 460.892517,833.758118 471.491516,827.127258 
	C472.978577,826.196899 474.396423,823.275330 474.072662,821.623047 
	C470.958771,805.731873 467.406616,789.927368 464.094696,774.074036 
	C460.741089,758.021240 457.545898,741.935364 454.229614,725.874695 
	C449.614044,703.521362 445.526520,681.034790 440.024933,658.900574 
	C437.813416,650.003113 438.440704,641.863342 441.560638,634.030151 
	C443.613464,628.876038 448.004303,624.587158 451.636505,620.146606 
	C455.351135,615.605103 459.417511,611.351257 463.683777,607.389465 
	C464.050659,640.633728 464.048920,673.460083 464.114655,706.286316 
	C464.118500,708.206177 464.667664,710.125061 464.963043,712.044373 
z"
      />
      <path
        fill="#1171B7"
        opacity="1.000000"
        stroke="none"
        d="
M513.764404,1634.996704 
	C506.287140,1635.626831 499.280273,1636.266113 492.270691,1636.874023 
	C487.690033,1637.271484 483.102936,1637.594849 478.523132,1638.001343 
	C467.602509,1638.970703 456.691528,1640.057983 445.763306,1640.930054 
	C436.442352,1641.673950 427.088593,1642.023193 417.775421,1642.843262 
	C408.161743,1643.689575 398.585938,1644.958740 388.979553,1645.899780 
	C386.228333,1646.169312 383.428406,1645.941284 380.016052,1645.941284 
	C379.668488,1631.043091 379.355865,1616.665527 378.990570,1602.289307 
	C378.691895,1590.535889 378.337524,1578.783936 377.994598,1567.031616 
	C377.671143,1555.947021 377.328735,1544.863037 376.997925,1533.778687 
	C376.662079,1522.526001 376.332001,1511.273438 375.996185,1500.020752 
	C375.665375,1488.936401 375.328705,1477.852173 374.997894,1466.767822 
	C374.662109,1455.515259 374.393982,1444.260132 373.958496,1433.011475 
	C373.825500,1429.576050 373.237335,1426.158325 372.857605,1422.732422 
	C373.342865,1422.639771 373.828125,1422.547241 374.313385,1422.454590 
	C378.793884,1433.296631 383.331482,1444.115479 387.744629,1454.984863 
	C403.145721,1492.917358 418.505676,1530.866699 433.876373,1568.811523 
	C436.589996,1575.510498 439.043488,1582.329712 442.101562,1588.866699 
	C443.263794,1591.351074 445.384033,1593.993774 447.760620,1595.208008 
	C467.506775,1605.296875 487.354889,1615.194336 507.352142,1624.773926 
	C509.809387,1625.951294 513.640625,1625.770752 516.304932,1624.785522 
	C588.371643,1598.137939 660.368835,1571.302490 732.379944,1544.504639 
	C733.761597,1543.990601 735.169922,1543.548462 737.378906,1542.795776 
	C735.517883,1567.148071 733.698486,1590.955933 731.837830,1615.303467 
	C723.042908,1616.119751 714.309021,1616.883301 705.585510,1617.751099 
	C691.733154,1619.128784 677.899719,1620.710327 664.035278,1621.947998 
	C654.564453,1622.793457 645.036438,1623.000488 635.566223,1623.851074 
	C622.198669,1625.051880 608.873047,1626.719482 595.506042,1627.927124 
	C586.202026,1628.767456 576.844116,1629.004883 567.536438,1629.813232 
	C557.589783,1630.677124 547.682556,1631.986938 537.741028,1632.920166 
	C532.683716,1633.395020 527.581665,1633.376221 522.513855,1633.764282 
	C519.738647,1633.976685 516.992737,1634.570801 513.764404,1634.996704 
z"
      />
      <path
        fill="#1070B7"
        opacity="1.000000"
        stroke="none"
        d="
M649.649048,886.279785 
	C650.500061,900.295837 650.997986,914.100830 651.333374,927.909790 
	C651.745789,944.890076 651.925659,961.876648 652.454163,978.852783 
	C652.541382,981.655640 651.592834,982.950867 649.389038,984.296753 
	C639.160156,990.543396 629.090942,997.053284 618.810120,1003.211060 
	C617.320251,1004.103455 614.648621,1004.344910 613.106079,1003.630493 
	C587.450623,991.748657 561.902222,979.635620 536.281555,967.677979 
	C533.880310,966.557251 532.794067,965.339417 532.798706,962.506897 
	C532.889832,906.507263 532.866699,850.507385 532.874695,794.507568 
	C532.874817,793.875854 532.978333,793.244141 533.136292,791.437744 
	C539.222534,798.431885 544.720154,804.728088 550.194641,811.044373 
	C570.705078,834.708801 591.241943,858.350586 611.667786,882.087891 
	C614.040283,884.844910 616.520203,886.150940 620.227783,886.074463 
	C629.889038,885.875183 639.557983,886.046814 649.649048,886.279785 
z"
      />
      <path
        fill="#1371B8"
        opacity="1.000000"
        stroke="none"
        d="
M833.236389,1368.899292 
	C809.326294,1374.637207 785.517090,1380.041504 760.913757,1385.626221 
	C763.422363,1352.874268 765.888489,1320.677856 768.354553,1288.481445 
	C768.556519,1288.407227 768.758423,1288.333008 768.960388,1288.258911 
	C770.000854,1291.475464 771.083374,1294.679077 772.074768,1297.910767 
	C777.532776,1315.702148 783.072021,1333.469849 788.339478,1351.317627 
	C789.661865,1355.798218 791.881958,1358.204590 796.628601,1359.279053 
	C808.934998,1362.064819 821.109924,1365.431152 833.236389,1368.899292 
z"
      />
      <path
        fill="#2277BB"
        opacity="1.000000"
        stroke="none"
        d="
M345.621307,803.765015 
	C346.883545,811.242798 349.724304,818.778931 345.216034,826.614014 
	C339.239990,837.000000 334.064606,847.846619 328.130432,858.344910 
	C332.195496,839.695801 338.537598,821.778809 345.621307,803.765015 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M465.011932,711.574829 
	C464.667664,710.125061 464.118500,708.206177 464.114655,706.286316 
	C464.048920,673.460083 464.050659,640.633728 464.031982,607.327515 
	C464.369476,608.320618 465.009430,609.793091 465.012024,611.266724 
	C465.070496,644.546204 465.059082,677.825684 465.011932,711.574829 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M1576.273804,1048.508789 
	C1585.747314,1048.343872 1595.552734,1048.433594 1605.711426,1048.735474 
	C1596.244873,1048.886230 1586.425415,1048.824829 1576.273804,1048.508789 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M1753.731079,1062.464233 
	C1744.261108,1062.637329 1734.460815,1062.553467 1724.316895,1062.246216 
	C1733.782471,1062.084229 1743.591553,1062.145752 1753.731079,1062.464233 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M1634.731079,1060.464111 
	C1625.254883,1060.639648 1615.448364,1060.558228 1605.288574,1060.264526 
	C1614.757202,1060.103882 1624.578979,1060.155518 1634.731079,1060.464111 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M1693.728882,1061.411865 
	C1684.583618,1061.601807 1675.102417,1061.543457 1665.258057,1061.285767 
	C1674.394287,1061.112183 1683.893555,1061.137939 1693.728882,1061.411865 
z"
      />
      <path
        fill="#0F70B7"
        opacity="1.000000"
        stroke="none"
        d="
M1393.031006,959.972900 
	C1392.612427,959.789368 1392.174072,959.625549 1391.735718,959.461731 
	C1392.142090,959.472351 1392.548340,959.482910 1392.964233,959.763794 
	C1392.973755,960.034119 1393.011108,959.992676 1393.031006,959.972900 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M1708.934082,1061.729980 
	C1708.849609,1061.912231 1708.662598,1061.942627 1708.206055,1061.882324 
	C1708.234863,1061.720337 1708.533081,1061.649292 1708.934082,1061.729980 
z"
      />
      <path
        fill="#B6C5E7"
        opacity="1.000000"
        stroke="none"
        d="
M1561.065918,1048.270020 
	C1561.150391,1048.087769 1561.337402,1048.057373 1561.793945,1048.117676 
	C1561.765137,1048.279663 1561.466797,1048.350830 1561.065918,1048.270020 
z"
      />
      <path
        fill="#D0D8F0"
        opacity="1.000000"
        stroke="none"
        d="
M944.925110,380.595764 
	C944.859863,380.801025 944.687500,380.860168 944.245117,380.878174 
	C944.255981,380.707916 944.536987,380.578766 944.925110,380.595764 
z"
      />
      <path
        fill="#FAFBFD"
        opacity="1.000000"
        stroke="none"
        d="
M1238.540649,1470.528809 
	C1231.463501,1471.250488 1224.845581,1472.061890 1218.203247,1472.423828 
	C1215.451782,1472.573975 1212.593262,1471.994263 1209.876099,1471.353149 
	C1159.859619,1459.551025 1109.860474,1447.676270 1059.840210,1435.890381 
	C1057.992920,1435.455078 1055.899780,1435.405884 1054.040894,1435.776733 
	C1028.757568,1440.819214 1003.500793,1445.994751 978.224121,1451.070801 
	C972.223450,1452.275879 970.391296,1450.995728 969.070618,1445.112427 
	C961.347778,1410.710815 953.723755,1376.286621 945.817932,1341.927124 
	C944.624512,1336.740112 945.974609,1333.960205 950.612000,1331.544189 
	C1018.315735,1296.271606 1085.952881,1260.871216 1153.604126,1225.497803 
	C1160.049438,1222.127808 1162.671631,1223.171021 1165.091187,1230.253052 
	C1169.874634,1244.254150 1174.437744,1258.333740 1179.452271,1272.250977 
	C1181.180542,1277.047607 1180.338013,1280.250122 1176.606689,1283.692261 
	C1162.179810,1297.000488 1148.004639,1310.581543 1133.191162,1324.575317 
	C1137.256836,1326.625488 1140.864380,1328.475830 1144.498779,1330.271729 
	C1157.325684,1336.610962 1170.213745,1342.829834 1182.952759,1349.340454 
	C1185.689453,1350.739014 1187.535156,1350.712036 1190.074219,1348.958130 
	C1203.085693,1339.970947 1216.317505,1331.302246 1229.295288,1322.268188 
	C1232.885986,1319.768799 1235.980591,1319.426514 1239.906738,1321.288940 
	C1251.020508,1326.561157 1262.267334,1331.552856 1273.457764,1336.663818 
	C1280.001465,1339.652466 1280.706177,1342.632690 1276.296509,1348.541016 
	C1275.815308,1349.185669 1275.373657,1349.859741 1274.067749,1351.733887 
	C1279.518433,1350.611938 1283.756836,1349.792847 1287.970459,1348.860718 
	C1295.764404,1347.136597 1303.542114,1345.338623 1311.329468,1343.584717 
	C1318.150024,1342.048706 1320.154785,1343.328979 1321.202759,1350.091797 
	C1322.782227,1360.284668 1324.190552,1370.504883 1325.837402,1380.686523 
	C1326.638428,1385.638550 1324.855713,1388.366455 1320.061523,1390.084229 
	C1305.577515,1395.274048 1291.222900,1400.824707 1276.962769,1407.099731 
	C1292.503784,1407.510986 1308.044922,1407.912720 1323.585571,1408.337402 
	C1330.737671,1408.532959 1337.890625,1408.721924 1345.039185,1409.010498 
	C1350.140991,1409.216431 1352.374878,1411.976929 1351.124756,1416.858521 
	C1347.782593,1429.909912 1344.247681,1442.911865 1340.834106,1455.945068 
	C1339.882568,1459.577759 1337.470825,1460.817261 1333.898804,1461.158813 
	C1302.256226,1464.184570 1270.624756,1467.328369 1238.540649,1470.528809 
M1242.558594,1406.938965 
	C1266.320068,1397.958374 1290.081421,1388.977905 1314.038208,1379.923584 
	C1312.847656,1371.784302 1311.701904,1363.950928 1310.500854,1355.740112 
	C1308.654419,1356.078613 1307.206421,1356.294312 1305.781738,1356.612915 
	C1291.009644,1359.916870 1276.273926,1363.400024 1261.436768,1366.377930 
	C1259.212646,1366.824341 1255.605591,1365.607910 1254.325928,1363.897827 
	C1253.280151,1362.500488 1254.062012,1358.795166 1255.250854,1356.860962 
	C1257.739380,1352.811279 1261.030273,1349.254761 1264.290405,1345.116577 
	C1255.579590,1341.146240 1247.229248,1337.475464 1239.017212,1333.517578 
	C1236.432129,1332.271729 1234.592163,1332.562012 1232.304321,1334.133789 
	C1219.269287,1343.089966 1206.055054,1351.787354 1193.084839,1360.835083 
	C1189.344482,1363.444092 1186.189087,1363.855835 1182.081421,1361.720947 
	C1172.048218,1356.505981 1161.803833,1351.697876 1151.663940,1346.686890 
	C1141.971313,1341.896851 1132.285645,1337.091797 1122.630371,1332.227173 
	C1116.108765,1328.941284 1115.660645,1325.640869 1120.908203,1320.403320 
	C1121.732910,1319.580322 1122.592773,1318.792358 1123.439331,1317.991333 
	C1137.592896,1304.601807 1151.771973,1291.239258 1165.847168,1277.767944 
	C1166.855103,1276.803223 1167.925903,1274.780640 1167.578003,1273.695557 
	C1163.744263,1261.736694 1159.635132,1249.866089 1155.517212,1237.725952 
	C1154.084595,1238.367188 1153.167603,1238.720581 1152.302368,1239.172974 
	C1088.767090,1272.392944 1025.251587,1305.651001 961.659302,1338.761475 
	C958.358887,1340.480103 957.562683,1342.073486 958.400146,1345.669556 
	C963.152649,1366.078003 967.623108,1386.552246 972.220215,1406.997192 
	C974.614197,1417.643799 977.071289,1428.276489 979.558838,1439.173340 
	C1000.398804,1434.910522 1020.725830,1430.614868 1041.118530,1426.657837 
	C1048.031860,1425.316284 1054.742188,1422.651123 1062.187744,1424.442505 
	C1111.994385,1436.425537 1161.843994,1448.231079 1211.710327,1459.964233 
	C1215.026611,1460.744629 1218.638184,1460.919189 1222.038086,1460.595825 
	C1254.182617,1457.537354 1286.302856,1454.221680 1318.448608,1451.177002 
	C1330.325928,1450.052124 1330.363770,1450.295044 1333.495972,1438.663574 
	C1335.112183,1432.662598 1336.662842,1426.644043 1338.609497,1419.239502 
	C1326.716187,1419.239502 1315.919556,1419.393677 1305.128906,1419.205688 
	C1285.818848,1418.869385 1266.507812,1418.444092 1247.209717,1417.723145 
	C1244.781494,1417.632446 1241.527710,1416.090942 1240.337280,1414.176514 
	C1239.450928,1412.750854 1241.280640,1409.636597 1242.558594,1406.938965 
z"
      />
      <path
        fill="#1070B7"
        opacity="1.000000"
        stroke="none"
        d="
M1242.229614,1407.106689 
	C1241.280640,1409.636597 1239.450928,1412.750854 1240.337280,1414.176514 
	C1241.527710,1416.090942 1244.781494,1417.632446 1247.209717,1417.723145 
	C1266.507812,1418.444092 1285.818848,1418.869385 1305.128906,1419.205688 
	C1315.919556,1419.393677 1326.716187,1419.239502 1338.609497,1419.239502 
	C1336.662842,1426.644043 1335.112183,1432.662598 1333.495972,1438.663574 
	C1330.363770,1450.295044 1330.325928,1450.052124 1318.448608,1451.177002 
	C1286.302856,1454.221680 1254.182617,1457.537354 1222.038086,1460.595825 
	C1218.638184,1460.919189 1215.026611,1460.744629 1211.710327,1459.964233 
	C1161.843994,1448.231079 1111.994385,1436.425537 1062.187744,1424.442505 
	C1054.742188,1422.651123 1048.031860,1425.316284 1041.118530,1426.657837 
	C1020.725830,1430.614868 1000.398804,1434.910522 979.558838,1439.173340 
	C977.071289,1428.276489 974.614197,1417.643799 972.220215,1406.997192 
	C967.623108,1386.552246 963.152649,1366.078003 958.400146,1345.669556 
	C957.562683,1342.073486 958.358887,1340.480103 961.659302,1338.761475 
	C1025.251587,1305.651001 1088.767090,1272.392944 1152.302368,1239.172974 
	C1153.167603,1238.720581 1154.084595,1238.367188 1155.517212,1237.725952 
	C1159.635132,1249.866089 1163.744263,1261.736694 1167.578003,1273.695557 
	C1167.925903,1274.780640 1166.855103,1276.803223 1165.847168,1277.767944 
	C1151.771973,1291.239258 1137.592896,1304.601807 1123.439331,1317.991333 
	C1122.592773,1318.792358 1121.732910,1319.580322 1120.908203,1320.403320 
	C1115.660645,1325.640869 1116.108765,1328.941284 1122.630371,1332.227173 
	C1132.285645,1337.091797 1141.971313,1341.896851 1151.663940,1346.686890 
	C1161.803833,1351.697876 1172.048218,1356.505981 1182.081421,1361.720947 
	C1186.189087,1363.855835 1189.344482,1363.444092 1193.084839,1360.835083 
	C1206.055054,1351.787354 1219.269287,1343.089966 1232.304321,1334.133789 
	C1234.592163,1332.562012 1236.432129,1332.271729 1239.017212,1333.517578 
	C1247.229248,1337.475464 1255.579590,1341.146240 1264.290405,1345.116577 
	C1261.030273,1349.254761 1257.739380,1352.811279 1255.250854,1356.860962 
	C1254.062012,1358.795166 1253.280151,1362.500488 1254.325928,1363.897827 
	C1255.605591,1365.607910 1259.212646,1366.824341 1261.436768,1366.377930 
	C1276.273926,1363.400024 1291.009644,1359.916870 1305.781738,1356.612915 
	C1307.206421,1356.294312 1308.654419,1356.078613 1310.500854,1355.740112 
	C1311.701904,1363.950928 1312.847656,1371.784302 1314.038208,1379.923584 
	C1290.081421,1388.977905 1266.320068,1397.958374 1242.229614,1407.106689 
z"
      />
    </svg>
  );
};

ImaginationAndCreativityIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

ImaginationAndCreativityIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default ImaginationAndCreativityIllustration;
